// utils/api/ApiUtils.js

const API_BASE_URL = '/api';

// Helper function to get auth headers with optional class context
export const getAuthHeaders = (classContext = null) => {
  const userRole = localStorage.getItem('userRole');
  const username = localStorage.getItem('username');
  
  const headers = {
    'Content-Type': 'application/json',
  };
  
  // Add the headers your Flask API expects
  if (userRole) {
    headers['User-Role'] = userRole;
  }
  
  if (username) {
    headers['Requesting-User'] = username;
  }
  
  // Add class context headers if provided
  if (classContext) {
    if (classContext.class_id && classContext.class_id !== 'all') {
      headers['Class-ID'] = classContext.class_id.toString();
    }
    if (classContext.class_code && classContext.class_code !== 'ALL') {
      headers['Class-Code'] = classContext.class_code;
    }
  }
  
  return headers;
};

// Generic API call function with optional class context
export const apiCall = async (endpoint, options = {}, classContext = null) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const config = {
    ...options,
    credentials: 'include',
    cache: 'no-store', // never use cached responses
    headers: {
      ...getAuthHeaders(classContext),
      ...(options.headers || {})
    }
  };
  
  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      if (response.status === 401) {
        // Clear auth and redirect to login
        localStorage.clear();
        window.location.reload();
        throw new Error('Authentication required');
      }
      
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errorData.error || `HTTP ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API Error [${endpoint}]:`, error);
    throw error;
  }
};